import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { ROUTES } from "@/shared/config";
import { ScreenState } from "@/widgets/screen-state";

export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ScreenState
      tone="info"
      icon="questionMark"
      title={t("states.notFound.title")}
      body={t("states.notFound.body")}
      action={{
        label: t("states.notFound.action"),
        onClick: () => {
          void navigate(ROUTES.home);
        },
      }}
    />
  );
}
